import React, { useState } from "react";
import { BiCheck, BiX, BiArrowBack, BiCrown, BiStar, BiShield, BiRocket, BiTime } from "react-icons/bi";
import { FaGem, FaCrown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PricingCart = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [formData, setFormData] = useState({ name: "", phone: "", message: "" });
  const navigate = useNavigate();

  const handleChoosePlan = (planName) => {
    setSelectedPlan(planName);
    setShowPopup(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Show success message
    Swal.fire({
      icon: "success",
      title: "Thank You!",
      text: "We'll contact you shortly regarding your plan.",
      confirmButtonColor: "#8B5CF6",
      background: "#1f2937",
      color: "#f3f4f6",
    });
    
    setShowPopup(false);
    setFormData({ name: "", phone: "", message: "" });
  };

  const benefits = [
    { icon: <BiRocket size={20} />, text: "Instant Access After Purchase" },
    { icon: <BiCrown size={20} />, text: "Premium Templates Included" },
    { icon: <BiShield size={20} />, text: "100% Satisfaction Guarantee" },
    { icon: <BiTime size={20} />, text: "24/7 Priority Support" },
  ];

  const planDetails = {
    name: "Premium Poster Plan",
    price: "499",
    originalPrice: "₹870.00",
    savings: "Save 43%",
    features: [
      "Ready-Made Festival Posters",
      "AI Background Remover Tool",
      "AI Text Remover Tool",
      "Birthday & Anniversary Reminders",
      "Professional Logo Maker",
      "Daily Online Panchang",
      "Business Spotlight Feature",
      "High-Resolution Downloads",
      "Multiple File Formats",
      "Custom Branding Options",
      "Unlimited Poster Downloads",
      "Priority Email Support",
      "Regular Template Updates",
      "Refer & Earn Program",
      "All Future Features Included",
    ],
    popular: true,
  };

  return (
    <>
    <Navbar/>
    <div className="bg-gradient-to-br from-gray-950 via-gray-900 to-purple-950 min-h-screen py-8 md:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Header Section */}
        <div className="text-center mb-8 md:mb-12">
          {/* Back Button */}
          {/* <div className="flex justify-start mb-6">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-gray-800 border border-gray-700 text-gray-300 font-medium text-sm hover:bg-gray-700 hover:border-purple-500/50 hover:text-purple-400 transition-all duration-300 group shadow-lg"
            >
              <BiArrowBack
                size={18}
                className="group-hover:-translate-x-1 transition-transform duration-200"
              />
              Back
            </button>
          </div> */}

          {/* Title */}
          <div className="space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/20">
              <FaGem size={14} className="text-purple-400" />
              <span className="text-purple-300 text-sm font-medium">Limited Time Offer</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
              <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
                Choose Your Plan
              </span>
            </h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Get unlimited access to premium templates, AI tools, and all features for an entire year
            </p>
          </div>
        </div>

        {/* Benefits Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 md:mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-4 flex items-center gap-3 hover:border-purple-500/30 transition-all duration-300 group"
            >
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                {benefit.icon}
              </div>
              <p className="text-gray-300 text-sm font-medium">{benefit.text}</p>
            </div>
          ))}
        </div>

        {/* Pricing Card */}
        <div className="max-w-2xl mx-auto">
          <div className="relative group">
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
            
            {/* Card */}
            <div className="relative bg-gray-900 border-2 border-purple-500/50 rounded-2xl overflow-hidden shadow-2xl shadow-purple-500/10">
              {/* Popular Badge */}
              <div className="absolute top-0 right-0">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-2 rounded-bl-2xl font-semibold text-sm flex items-center gap-2">
                  <FaCrown size={14} />
                  Most Popular
                </div>
              </div>

              <div className="p-6 sm:p-8 lg:p-10">
                {/* Plan Header */}
                <div className="text-center mb-8">
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 rounded-full border border-purple-500/20 mb-4">
                    <BiStar size={18} className="text-yellow-400" />
                    <span className="text-purple-300 text-sm font-medium">Premium Annual Plan</span>
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                    {planDetails.name}
                  </h2>
                  <p className="text-gray-400">Everything you need for professional poster creation</p>
                </div>

                {/* Price Section */}
                <div className="bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-2xl p-6 mb-8 border border-purple-500/20">
                  <div className="flex items-center justify-center gap-3 mb-4">
                    <span className="text-gray-500 line-through text-lg">
                      {planDetails.originalPrice}
                    </span>
                    <span className="bg-gradient-to-r from-green-400 to-emerald-400 text-black px-3 py-1 rounded-full text-sm font-bold">
                      {planDetails.savings}
                    </span>
                  </div>
                  
                  <div className="text-center">
                    <div className="text-5xl sm:text-6xl font-bold">
                      <span className="text-2xl text-gray-400">₹</span>
                      <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                        {planDetails.price}
                      </span>
                    </div>
                    <p className="text-gray-400 mt-2">per year</p>
                    <p className="text-gray-500 text-sm mt-1">That's just ₹41.58/month</p>
                  </div>
                </div>

                {/* Features Grid */}
                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                    <BiStar size={20} className="text-purple-400" />
                    Everything Included
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {planDetails.features.map((feature, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-3 group/item"
                      >
                        <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center flex-shrink-0 group-hover/item:scale-110 transition-transform duration-200">
                          <BiCheck size={16} className="text-white" />
                        </div>
                        <span className="text-gray-300 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* CTA Button */}
                <button
                  onClick={() => handleChoosePlan(planDetails.name)}
                  className="w-full py-4 px-6 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-[1.02] shadow-xl hover:shadow-2xl hover:shadow-purple-500/25 flex items-center justify-center gap-2 group"
                >
                  <FaCrown size={18} className="group-hover:animate-bounce" />
                  Get Started Now
                  <span className="text-purple-200 text-sm font-normal">— ₹{planDetails.price}/year</span>
                </button>

                {/* Money Back Guarantee */}
                <p className="text-center text-gray-500 text-sm mt-4 flex items-center justify-center gap-2">
                  <BiShield size={16} />
                  30-Day Money-Back Guarantee
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ or Additional Info */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Have questions? Contact us at{" "}
            <a href="mailto:editezy.contact@gmail.com" className="text-purple-400 hover:text-purple-300 transition-colors">
              editezy.contact@gmail.com
            </a>
          </p>
        </div>

        {/* Popup Modal */}
        {showPopup && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex justify-center items-center z-50 p-4">
            <div className="bg-gray-900 rounded-2xl p-6 sm:p-8 w-full max-w-md border border-gray-700 shadow-2xl transform transition-all">
              {/* Modal Header */}
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl sm:text-2xl font-bold">
                  <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                    Complete Your Order
                  </span>
                </h2>
                <button
                  onClick={() => setShowPopup(false)}
                  className="w-10 h-10 rounded-xl bg-gray-800 border border-gray-700 flex items-center justify-center text-gray-400 hover:text-white hover:border-gray-600 transition-all"
                >
                  <BiX size={22} />
                </button>
              </div>

              {/* Selected Plan Info */}
              <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 rounded-xl p-4 mb-6 border border-purple-500/20">
                <p className="text-gray-400 text-sm mb-1">Selected Plan</p>
                <p className="text-white font-bold text-lg">{selectedPlan}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-gray-500 line-through text-sm">{planDetails.originalPrice}</span>
                  <span className="text-2xl font-bold text-purple-400">₹{planDetails.price}/year</span>
                </div>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-gray-300 text-sm font-medium mb-2">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    className="w-full bg-gray-800 border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all outline-none"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-300 text-sm font-medium mb-2">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    className="w-full bg-gray-800 border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all outline-none"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-300 text-sm font-medium mb-2">Message (Optional)</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Any specific requirements?"
                    rows="3"
                    className="w-full bg-gray-800 border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all outline-none resize-none"
                  />
                </div>

                <div className="flex gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => setShowPopup(false)}
                    className="flex-1 py-3 px-4 bg-gray-800 border border-gray-700 text-gray-300 rounded-xl hover:bg-gray-700 transition-all font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="flex-1 py-3 px-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all font-bold shadow-lg hover:shadow-purple-500/25"
                  >
                    Proceed to Pay ₹{planDetails.price}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default PricingCart;